import { styled } from "styled-components";
const ConfirmationDialogInner = styled.div`
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: auto 1fr;
  padding: 14px 16px;
`;
const ConfirmationDialogHeader = styled("h3")(({ theme }) => ({
  color: theme.color.black9,
  fontSize: theme.fontSize.lg,
  fontWeight: theme.fontWeight.medium,
  lineHeight: theme.lineHeight.lg,
  margin: "0 0 8px"
}));
const ConfirmationDialogBody = styled.div`
  font-size: ${({ theme }) => theme.fontSize.default};
  line-height: ${({ theme }) => theme.lineHeight.default};
  margin-bottom: 16px;
`;
const ConfirmationDialogIcon = styled.div`
  color: ${({ theme }) => theme.color.yellow6};
  font-size: 18px;
  grid-row: 1 / span 2;
  line-height: 28px;
`;
const ConfirmationDialogFooter = styled.div`
  white-space: nowrap;
  grid-column: 2;
`;
export {
  ConfirmationDialogBody,
  ConfirmationDialogFooter,
  ConfirmationDialogHeader,
  ConfirmationDialogIcon,
  ConfirmationDialogInner
};
